import { Component, signal, computed, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CompetitionDate } from './models/competition-dates.model';
import { Data } from '../../core/services/data';

interface SortConfig {
  column: keyof CompetitionDate | '';
  direction: 'asc' | 'desc' | '';
}

@Component({
  selector: 'app-competition-dates',
  imports: [FormsModule],
  templateUrl: './competition-dates.html',
  styleUrl: './competition-dates.css'
})
export class CompetitionDatesComponent implements OnInit {
  private dataService = inject(Data);

  competitions = signal<CompetitionDate[]>([]);
  searchTerm = signal('');
  sortConfig = signal<SortConfig>({ column: '', direction: '' });
  isLoading = signal(true);
  error = signal<string | null>(null);

  filteredCompetitions = computed(() => {
    const term = this.searchTerm().toLowerCase().trim();
    let filtered = this.competitions();

    if (term) {
      filtered = filtered.filter(competition =>
        competition.disziplinen.some(d =>
          d.code.toLowerCase().includes(term) ||
          d.name.toLowerCase().includes(term)
        ) ||
        competition.klassen.toLowerCase().includes(term) ||
        competition.anlagen.some(a => a.toLowerCase().includes(term)) ||
        competition.termine.some(t =>
          t.anlage.toLowerCase().includes(term) ||
          t.anmerkung.toLowerCase().includes(term)
        ) ||
        competition.anmerkungen.some(a => a.toLowerCase().includes(term))
      );
    }

    return filtered;
  });

  ngOnInit(): void {
    this.loadCompetitions();
  }

  loadCompetitions(): void {
    this.isLoading.set(true);
    this.error.set(null);

    this.dataService.getCompetitionDates().subscribe({
      next: (data) => {
        this.competitions.set(data);
        this.isLoading.set(false);
      },
      error: (err) => {
        console.error('Error loading competition dates:', err);
        this.error.set('Fehler beim Laden der Wettkampftermine');
        this.isLoading.set(false);
      }
    });
  }

  onSearchChange(value: string): void {
    this.searchTerm.set(value);
  }

  formatDate(date: Date): string {
    return date.toLocaleDateString('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  clearSearch(): void {
    this.searchTerm.set('');
  }
}
